import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import * as S from '@/lib/settings/service';
import { Field, Loading, SchemaNotice } from '@/components/common/F1States';

export const ApprovalPolicyForm = ({ organisationId, canEdit }) => {
  const settings = useSWR(['org-settings', organisationId], () => S.getOrgSettings(organisationId));
  const [f, setF] = useState({ approval_split_window_days: 14, default_vat_rate: 23 });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (settings.data) setF({ approval_split_window_days: settings.data.approval_split_window_days, default_vat_rate: settings.data.default_vat_rate }); }, [settings.data]);
  const save = async () => {
    setBusy(true);
    try { await S.saveOrgSettings(organisationId, { approval_split_window_days: Number(f.approval_split_window_days), default_vat_rate: Number(f.default_vat_rate) }); toast.success('Approval policy saved'); settings.mutate(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  if (settings.error) return <SchemaNotice error={settings.error} testId="policy-error" />;
  if (settings.isLoading) return <Loading />;
  return (
    <div className="rounded-lg border border-border bg-white p-4" data-testid="approval-policy-form">
      <div className="text-sm text-muted-foreground mb-3">Approval limits are always <strong>VAT-inclusive</strong>. {!settings.data && 'No policy row saved yet — the database defaults (14 days, 23% VAT) apply until the Owner saves one.'} Delegated limits themselves are granted under Approvals → Delegated authority.</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
        <Field label="Anti-splitting window (days)"><Input data-testid="policy-split-days" type="number" min="1" max="90" value={f.approval_split_window_days} onChange={(e) => setF((x) => ({ ...x, approval_split_window_days: e.target.value }))} disabled={!canEdit} /></Field>
        <Field label="Default VAT rate %"><Input data-testid="policy-vat-rate" type="number" min="0" max="100" step="0.5" value={f.default_vat_rate} onChange={(e) => setF((x) => ({ ...x, default_vat_rate: e.target.value }))} disabled={!canEdit} /></Field>
        {canEdit && <Button data-testid="policy-save" onClick={save} disabled={busy} className="bg-bronze hover:bg-bronze-hover text-white">{busy ? <Loader2 size={14} className="animate-spin" /> : 'Save policy'}</Button>}
      </div>
    </div>
  );
};
